import { Scrollbar } from "app/components/Scrollbar";

import { Notification } from "../entity";
import { NotificationListSection } from "./NotificationListSection";

export const NotificationList = ({
  notifications,
}: {
  notifications: Notification[];
}) => {
  return (
    <Scrollbar
      fillContent
      sx={{ maxHeight: { sm: "none", xs: 360 }, minHeight: 240 }}
    >
      <NotificationListSection
        notifications={notifications.slice(0, 2)}
        title="New"
      />
      <NotificationListSection
        notifications={notifications.slice(2, 5)}
        title="Before that"
      />
    </Scrollbar>
  );
};
